<template>
  <figure class="fade-item">
    <img
      :src="src"
      draggable="false"
      alt=""
      class="image"
    />
  </figure>
</template>

<script>
export default {
  name: 'FadeItem',
  props: {
    src: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-item {
  width: 100%;
  font-size: 0;
  text-align: center;
  height: 180px;

  @media (min-width: 768px) {
    height: 300px;
  }
}
.image {
  height: 180px;
  width: 300px;
  margin: 0 auto;
  display: block;

  @media (min-width: 768px) {
    height: 300px;
    width: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fader/FadeItem.vue